import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Services from './pages/Services';
import Contact from './pages/Contact';
import SocialMediaMarketing from './pages/services/SocialMediaMarketing';
import SocialMediaOptimization from './pages/services/SocialMediaOptimization';
import WhatsappMarketing from './pages/services/WhatsappMarketing';
import GoogleAds from './pages/services/GoogleAds';
import MetaAds from './pages/services/MetaAds';
import WebsiteDesign from './pages/services/WebsiteDesign';
import WebsiteDevelopment from './pages/services/WebsiteDevelopment';
import DomainHosting from './pages/services/DomainHosting';
import WebsiteMaintenance from './pages/services/WebsiteMaintenance';
import ECommerce from './pages/services/ECommerce';
import GraphicDesign from './pages/services/GraphicDesign';
import './styles/global.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/about/team" element={<Team />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/social-media-marketing" element={<SocialMediaMarketing />} />
        <Route path="/services/social-media-optimization" element={<SocialMediaOptimization />} />
        <Route path="/services/whatsapp-marketing" element={<WhatsappMarketing />} />
        <Route path="/services/google-ads" element={<GoogleAds />} />
        <Route path="/services/meta-ads" element={<MetaAds />} />
        <Route path="/services/website-design" element={<WebsiteDesign />} />
        <Route path="/services/website-development" element={<WebsiteDevelopment />} />
        <Route path="/services/domain-hosting" element={<DomainHosting />} />
        <Route path="/services/website-maintenance" element={<WebsiteMaintenance />} />
        <Route path="/services/ecommerce-development" element={<ECommerce />} />
        <Route path="/services/graphic-design" element={<GraphicDesign />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
